import { push } from 'connected-react-router';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
export default (function () {
    var dispatch = useDispatch();
    var action = useCallback(function (path, state) { return dispatch(push(path, state)); }, [
        dispatch,
    ]);
    var handleAction = useCallback(function (path, state) { return function () { return action(path, state); }; }, [
        action,
    ]);
    return {
        push: action,
        handlePush: handleAction,
    };
});
//# sourceMappingURL=usePush.js.map